export default __webpack_public_path__ + "b20237996f0322417d99cf20b7fa7661.svg";